import { Component, Input } from '@angular/core'
import { ListingTransportAirportsGQL, ListingTransportAirportsQuery } from '../../../../../../../graphql'
import { UnsubscribeOnDestroy } from '../../../../../../utility'

@Component({
    selector: 'app-listing-transport',
    templateUrl: 'listing-transport.html'
})
export class ListingTransportComponent extends UnsubscribeOnDestroy {
    airports: ListingTransportAirportsQuery['airports']
    @Input() lat: number
    @Input() lng: number

    // Constructor
    constructor(private _listingTransportAirportsGQL: ListingTransportAirportsGQL) {
        super()
    }

    // Public
    ngAfterContentInit() {
        this.requestAirports()
    }

    // Private
    private requestAirports() {
        this._subscriptions.push(this._listingTransportAirportsGQL
            .watch({ location: { lat: this.lat, lng: this.lng } }, { fetchPolicy: 'no-cache' })
            .valueChanges
            .subscribe(result => {
                if (!result.loading) { this.airports = result.data.airports }
            }))
    }
}
